import { Calendar, EllipsisVertical, Pill } from "lucide-react";
import React, { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "src/components/app/layout/Header";
import LogHistory from "src/components/app/log-details/LogHistory";
import LogTrends from "src/components/app/log-details/LogTrends";
import MenstrualCalendar from "src/components/app/insights/MenstrualCalendar";
import Tabs from "src/components/app/Tabs";

const MenstruationLogDetailsScreen: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("trends");
  const queryParams = new URLSearchParams(location.search);
  const logDetailsScreenKey = queryParams.get("log");

  const screenTabs = [
    {
      id: "trends",
      title: "Trends",
    },
    {
      id: "history",
      title: "History",
    },
  ];

  const handleTabChange = useCallback(
    (tabId: string) => {
      setActiveTab(tabId);
    },
    [activeTab]
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="relative h-[calc(100vh-75px)] overflow-y-auto">
        <div className="fixed top-0 left-0 right-0 z-10">
          <Header
            titlePosition="center"
            title="Menstruation Logs"
            onBackClick={() => navigate(-1)}
          />
          <div className="p-4 space-y-4 bg-white border-b border-gray-200">
            <Tabs
              tabs={screenTabs}
              activeTab={activeTab}
              onChange={(tab) => setActiveTab(tab.id)}
            />
          </div>
        </div>
        <div className="w-full mt-32">
          {activeTab === "trends" ? (
            <LogTrends
              className="h-auto"
              logDetailsScreenKey={logDetailsScreenKey}
              chartSection={<MenstrualCalendar />}
            />
          ) : activeTab === "history" ? (
            <LogHistory logDetailsScreenKey={logDetailsScreenKey || ""} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MenstruationLogDetailsScreen;
